import axios from 'axios'

const API_BASE = process.env.REACT_APP_NEXTERA_API

export interface SiteWalkStitchStatus {
  pending: number
  complete: number
  failed_heuristic: number
  total: number
  site_walk_id: number
  project_public_id: string
}

export interface SiteWalkEnqueueStitchingResult {
  enqueued: number
  pending: number
  complete: number
  failed_heuristic: number
  total: number
  site_walk_id: number
  project_public_id: string
}

export const fetchSiteWalkStitchStatus = async (
  projectPublicId: string,
  siteWalkId: number,
): Promise<SiteWalkStitchStatus> => {
  const response = await axios.get(
    `${API_BASE}/project/${encodeURIComponent(projectPublicId)}/site-walk/${siteWalkId}/stitch-status`,
  )
  return response.data.data ?? response.data
}

export const enqueueSiteWalkStitching = async (
  projectPublicId: string,
  siteWalkId: number,
): Promise<SiteWalkEnqueueStitchingResult> => {
  const response = await axios.post(
    `${API_BASE}/project/${encodeURIComponent(projectPublicId)}/site-walk/${siteWalkId}/enqueue-stitching`,
  )
  return response.data.data ?? response.data
}
